import Effects from 'Effects';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Tone from 'tone';
import {AudioParamPercentageValueParameter,
        AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';
import HasTrack from './HasTrack.js';
        
export default class FollowerEffect extends HasTrack(Effects.Effect) {
    constructor(sequencerEngine) {
        super('Follower', () => new Tone.Gain(1), sequencerEngine); 
        
        this.follower = new Tone.Follower();
        this.follower.connect(this.effectNode.gain);

        this.roughnessParameter = new AudioParamValueParameter(
            'roughness', this.follower._filter.frequency,
            {
                defaultValue: 10,
                min: 0.1,
                max: 100
            });

        this.setupTrackParameter();
        this.updateInitialValues();
   }

    onChangeTrack(track) {
        if (track === -1) {
            this._track = undefined;
            return;
        }
        track = this.sequencerEngine.tracks[track];
        if (this._track) {
            this._track.volumeNode.disconect(this.follower);
        }

        track.volumeNode.connect(this.follower);
        super.onChangeTrack(track);
    }

    getJson(isPreset) {
        let json = {
            ... super.getJson(isPreset),
            roughness: this.roughnessParameter.get(true),
            track: this.trackParameter.get(true)
        };

        json = this.saveParameterToJson(json, 'roughnessParameter', this.roughnessParameter);
        return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        bulkUpdate(this.roughnessParameter, json.roughness, bulk);
        bulkUpdate(this.trackParameter, json.track, bulk);

        return {
            ... bulk,
            ... this.loadParameterFromJson(json, 'roughnessParameter', this.roughnessParameter),
        };
    }

    getEffectCopy(sequencerEngine, ignoreId=true) {
        let fx = new FollowerEffect(sequencerEngine);
        fx.fromJson(this.getJson(), ignoreId);
        return true;
    }
}
 
